export enum InsurancesRoutes {
    ROUTE_INSURANCES_OVERVIEW = `/mis-seguros`,
}
